module.exports = __webpack_public_path__ + "61972b232b81c2bd692243524de06247.jpg";